"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MAX_SAFE_INTEGER = exports.react_core_config = exports.defaultDateTimeFormatFallback = exports.defaultTimeFormat = exports.defaultDateTimeFormat = exports.defaultDateFormat = void 0;
exports.defaultDateFormat = 'MMMM DD, YYYY';
exports.defaultDateTimeFormat = 'MMMM DD, YYYY, hh:mm A';
exports.defaultTimeFormat = 'hh:mm A';
exports.defaultDateTimeFormatFallback = 'MMMM DD, YYYY, hh:mm A';
class Config {
    constructor() {
        this._internalConfig = {
            pointsFormat: '0,0',
            currencyFormat: '$0,0[.]00',
            currencyFormatWithDecimal: '$0,0.00',
            lotteryTimeZone: 'Universal',
            maxDateOfBirth: undefined,
            minDateOfBirth: undefined,
            gameType: '',
            instantGameType: 1,
            showGameTypeFilter: false,
            hideTopPrizeFilter: false,
            defaultDateFormat: exports.defaultDateFormat,
            defaultDateTimeFormat: exports.defaultDateTimeFormat,
            defaultTimeFormat: exports.defaultTimeFormat,
            defaultDateTimeFormatFallback: exports.defaultDateTimeFormatFallback,
            addressBaseUrl: '',
            promoEndingSoonDays: undefined,
            arcadeGameType: undefined,
            lotteryId: 49,
            gatewayV2: false,
            skipGender: false,
            skipPhone: true,
            usaOnlyZipcode: true
        };
        this.defaultDateTimeFormatFallback = () => !!this.internalConfig.defaultDateTimeFormatFallback
            ? this.internalConfig.defaultDateTimeFormatFallback
            : exports.defaultDateTimeFormatFallback;
        this.defaultDateFormat = () => !!this.internalConfig.defaultDateFormat
            ? this.internalConfig.defaultDateFormat
            : exports.defaultDateFormat;
        this.defaultDateTimeFormat = () => !!this.internalConfig.defaultDateTimeFormat
            ? this.internalConfig.defaultDateTimeFormat
            : exports.defaultDateTimeFormat;
        this.defaultTimeFormat = () => !!this.internalConfig.defaultTimeFormat
            ? this.internalConfig.defaultTimeFormat
            : exports.defaultTimeFormat;
    }
    set internalConfig(value) {
        this._internalConfig = Object.assign(Object.assign({}, this._internalConfig), value);
    }
    get internalConfig() {
        return this._internalConfig;
    }
    setInternalConfig(value) {
        Object.assign(this._internalConfig, value);
    }
}
const react_core_config = new Config();
exports.react_core_config = react_core_config;
exports.MAX_SAFE_INTEGER = 2147483647;
//# sourceMappingURL=config.js.map